// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/icons/ic-alarm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/icons/ic-device.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/icons/ic-sample-condition.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/icons/ic-alarm-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/icons/ic-device-active-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/icons/ic-sample-condition-active-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/icons/ic-service-mode.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/icons/ic-command-list.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/icons/ic-valve.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/icons/ic-calibrate.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/icons/ic-refresh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/icons/ic-refresh2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/icons/ic-refresh3.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remaining icon classes — used by ServiceModeButton, MoreCommandButton,
   SampleItem, and CommandsList (dynamic icon-custom-\${item.icon}).
   Icons replaced with MUI equivalents have been removed. */

[class^="icon-custom-"],
[class*=" icon-custom-"] {
  background-position: center center;
  height: 32px;
  width: 32px;
  display: inline-block;
  vertical-align: middle;
  background-size: contain;
  -webkit-background-size: contain;
  -moz-background-size: contain;
  background-repeat: no-repeat;
}

[class^="icon-sampleview-"],
[class*=" icon-sampleview-"] {
  height: 24px;
  width: 24px;
  -webkit-background-size: contain;
  -moz-background-size: contain;
  background-repeat: no-repeat;
}

/* Sample view icons (SampleItem.jsx) */
.icon-sampleview-alarm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.icon-sampleview-device {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.icon-sampleview-sample {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.highlighted .icon-sampleview-alarm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.highlighted .icon-sampleview-device {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.highlighted .icon-sampleview-sample {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

/* Service mode (ServiceModeButton.jsx) */
.icon-custom-service-mode {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.icon-circle-custom-service-mode {
  width: 48px;
  height: 48px;
  border-radius: 1000px;
  background: var(--os-surface-muted);
  display: inline-block;
  text-align: center;
  line-height: 48px;
}

/* Command list icon (MoreCommandButton.jsx) */
.icon-custom-command {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  width: 26px;
  height: 26px;
}

/* Dynamic command icons — used via icon-custom-\${item.icon} in CommandsList.jsx.
   Icon names come from API config (e.g., "valve", "refresh", "calibrate"). */
.icon-custom-valve {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  width: 60px;
  height: 24px;
}

.icon-custom-calibrate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 24px;
  height: 24px;
}

.icon-custom-refresh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.icon-custom-refresh2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.icon-custom-refresh3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/assets/css/icons.css"],"names":[],"mappings":"AAAA;;2DAE2D;;AAE3D;;EAEE,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,yDAAqD;AACvD;AACA;EACE,yDAAsD;AACxD;AACA;EACE,yDAAgE;AAClE;;AAEA;EACE,yDAA4D;AAC9D;AACA;EACE,yDAAiE;AACnE;AACA;EACE,yDAA2E;AAC7E;;AAEA,yCAAyC;AACzC;EACE,yDAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,yDAA4D;EAC5D,WAAW;EACX,YAAY;AACd;;AAEA;6EAC6E;AAC7E;EACE,yDAAqD;EACrD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAyD;EACzD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAAuD;AACzD;;AAEA;EACE,0DAAwD;AAC1D;;AAEA;EACE,0DAAwD;AAC1D","sourcesContent":["/* Remaining icon classes — used by ServiceModeButton, MoreCommandButton,\n   SampleItem, and CommandsList (dynamic icon-custom-${item.icon}).\n   Icons replaced with MUI equivalents have been removed. */\n\n[class^=\"icon-custom-\"],\n[class*=\" icon-custom-\"] {\n  background-position: center center;\n  height: 32px;\n  width: 32px;\n  display: inline-block;\n  vertical-align: middle;\n  background-size: contain;\n  -webkit-background-size: contain;\n  -moz-background-size: contain;\n  background-repeat: no-repeat;\n}\n\n[class^=\"icon-sampleview-\"],\n[class*=\" icon-sampleview-\"] {\n  height: 24px;\n  width: 24px;\n  -webkit-background-size: contain;\n  -moz-background-size: contain;\n  background-repeat: no-repeat;\n}\n\n/* Sample view icons (SampleItem.jsx) */\n.icon-sampleview-alarm {\n  background-image: url(\"../images/icons/ic-alarm.svg\");\n}\n.icon-sampleview-device {\n  background-image: url(\"../images/icons/ic-device.svg\");\n}\n.icon-sampleview-sample {\n  background-image: url(\"../images/icons/ic-sample-condition.svg\");\n}\n\n.highlighted .icon-sampleview-alarm {\n  background-image: url(\"../images/icons/ic-alarm-active.svg\");\n}\n.highlighted .icon-sampleview-device {\n  background-image: url(\"../images/icons/ic-device-active-red.svg\");\n}\n.highlighted .icon-sampleview-sample {\n  background-image: url(\"../images/icons/ic-sample-condition-active-red.svg\");\n}\n\n/* Service mode (ServiceModeButton.jsx) */\n.icon-custom-service-mode {\n  background-image: url(\"../images/icons/ic-service-mode.svg\");\n}\n\n.icon-circle-custom-service-mode {\n  width: 48px;\n  height: 48px;\n  border-radius: 1000px;\n  background: var(--os-surface-muted);\n  display: inline-block;\n  text-align: center;\n  line-height: 48px;\n}\n\n/* Command list icon (MoreCommandButton.jsx) */\n.icon-custom-command {\n  background-image: url(\"../images/icons/ic-command-list.svg\");\n  width: 26px;\n  height: 26px;\n}\n\n/* Dynamic command icons — used via icon-custom-${item.icon} in CommandsList.jsx.\n   Icon names come from API config (e.g., \"valve\", \"refresh\", \"calibrate\"). */\n.icon-custom-valve {\n  background-image: url(\"../images/icons/ic-valve.svg\");\n  width: 60px;\n  height: 24px;\n}\n\n.icon-custom-calibrate {\n  background-image: url(\"../images/icons/ic-calibrate.svg\");\n  width: 24px;\n  height: 24px;\n}\n\n.icon-custom-refresh {\n  background-image: url(\"../images/icons/ic-refresh.svg\");\n}\n\n.icon-custom-refresh2 {\n  background-image: url(\"../images/icons/ic-refresh2.svg\");\n}\n\n.icon-custom-refresh3 {\n  background-image: url(\"../images/icons/ic-refresh3.svg\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
